export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])},
        "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network"])},
        "container_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container Type"])},
        "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])}
      },
      "fr": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement..."])},
        "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réseau"])},
        "container_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de conteneur"])},
        "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Récipient"])}
      }
    }
  })
}